import AppearanceMenuBody from "./AppearanceMenuBody";
import Button from "./Button";
import VisibilityMenuBody from "./VisibilityMenuBody";

export default {
  AppearanceMenuBody,
  Button,
  VisibilityMenuBody
};
